<template>
  <div class="container">
    
    <div class="row">
      <div class="col-12">
        <div class="products-title">
          Supported Products
	</div>
	<div class="d-flex align-items-center justify-content-center" style="height:300px;">
	  <EasyDataTable
	    table-class-name="custom"
	    style="width: 100%;"
	    v-model:server-options="serverOptions"
	    :server-items-length="serverItemsLength"
	    :loading="loading"
	    :headers="headers"
	    :items="items"
	      :body-row-class-name="bodyRowClassNameFunction"
	    :rowsItems=[10,20,50]
	    :mustSort=true
	    @click-row="selectVersionInfo"
	    border-cell
	    />
	</div>
      </div>
    </div>
  </div>

  <div class="container mt-4 mb-4">
    <form>
      <div class="card">
	<div class="card-header text-left">Latest Version Info</div>
        <div class="card-body">
          <div class="form-group row">
            <label for="select2" class="col-sm-2 col-form-label">Software Type</label>
            <div class="col-sm-10 text-left pad-4">
              <select class="custom-select size-select1 form-control" id="select1" v-model="software_type" @change="checkVersionInfo">
                <option selected></option>
		<option v-for="option in software_type_list" :value="option.value">
		  {{ option.value }}
		</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="select2" class="col-sm-2 col-form-label">Target OS</label>
            <div class="col-sm-10 text-left pad-4">
              <select class="custom-select size-select2 form-control" id="select2" v-model="target_os" @change="checkVersionInfo">
                <option selected></option>
		<option v-for="option in target_os_list" :value="option.value">
		  {{ option.text }}
		</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label for="latest-version" class="col-sm-2 col-form-label">Latest Version</label>
            <div class="col-sm-10 form-inline pad-4">
              <input type="text" class="form-control" id="latest-version" name="latest-version" v-model="latest_version">
            </div>
          </div>
          <div class="form-group row">
            <label for="default-url" class="col-sm-2 col-form-label">English Download URL</label>
            <div class="col-sm-10 pad-4">
              <input type="text" class="form-control" id="default-url" name="default-url" v-model="default_download_url">
            </div>
          </div>
          <div class="form-group row">
            <label for="japan-url" class="col-sm-2 col-form-label">Japanese Download URL</label>
            <div class="col-sm-10 pad-4">
              <input type="text" class="form-control" id="japan-url" name="japan-url" v-model="japanese_download_url">
            </div>
          </div>

          <div class="form-group row">
            <label for="release-date" class="col-sm-2 col-form-label">Release Date (JST)</label>
	    <datepicker
	      class="col-sm-4 form-inline pad-4"
	      v-model="release_date"
	      />
          </div>

          <div class="form-group row">
            <label for="tel1" class="col-sm-2 col-top-label">Release Note</label>
            <div class="col-sm-10 form-inline pad-4">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-9" style="padding-left: 0">
                    <div class="form-group">
                      <textarea class="form-control" style="width: 100%; height: 200px;" id="exampleFormControlTextarea1" rows="3" v-model="release_note"></textarea>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="add" v-bind:disabled="disable_add">Add</button></div>
                      </div>
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="update" v-bind:disabled="disable_update">Update</button></div>
                      </div>
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="del" v-bind:disabled="disable_update">Delete</button></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <p class="linespace20"></p>
    <div class="text-right">
      <router-link to="./menu.html">
	<div class="greenbtnM">Close</div>
      </router-link>
    </div>
  </div>

  <ConfirmDialog />
  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { checkMaintenance, getProductList, getSoftwareTypeList, getTargetOSList, getVersionInfo, addVersionInfo, updateVersionInfo, deleteVersionInfo, checkVersion } from '../server';
import { error } from './ErrorDialog.vue';
import { confirm } from './ConfirmDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Product',
	value: 'software_name',
	sortable: true
    },
    {
	text: 'Software Type',
	value: 'software_code',
	sortable: true
    },
    {
	text: 'OS',
	value: 'target_os_name',
	sortable: true
    },
    {
	text: 'Latest Version',
	value: 'latest_version',
	sortable: true
    },
    {
	text: 'English Download URL',
	value: 'default_download_url',
	sortable: true
    },
    {
	text: 'Japanese Download URL',
	value: 'japanese_download_url',
	sortable: true
    }
];

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 10,
    sortBy: 'software_name',
    sortType: 'asc'
});

const loadFromServer = async() => {
    loading.value = true;
    try {
	let res = await getVersionInfo(serverOptions.value);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadFromServer();

watch(serverOptions, (value) => {loadFromServer(); }, { deep: true });

const software_type_list = ref([]);
const target_os_list = ref([]);

const loadSoftwareTypesFromServer = async() => {
    try {
	let res = await getSoftwareTypeList();
	software_type_list.value = res.softwareTypes;
    }
    catch(e) {
	console.log(e)
    }
};

const loadTargetOSFromServer = async() => {
    try {
	let res = await getTargetOSList(false);
	target_os_list.value = res.targetOS;
    }
    catch(e) {
	console.log(e)
    }
};

loadSoftwareTypesFromServer();
loadTargetOSFromServer();

const version_info_id = ref(0);
const software_type = ref(0);
const target_os = ref('');
const latest_version = ref('');
const default_download_url = ref('');
const japanese_download_url = ref('');
const release_date = ref('');
const release_note = ref('');

const disable_add = ref(true);
const disable_update = ref(true);

const add = async () => {
    if (!software_type.value) {
	error('Software Type is empty');
	return;
    }
    if (!target_os.value) {
	error('Target OS is empty');
	return;
    }
    if (!latest_version.value) {
	error('Latest Version is empty');
	return;
    }
    if (!default_download_url.value) {
	error('English Download URL is empty');
	return;
    }
    if (!japanese_download_url.value) {
	error('Japanese Download URL is empty');
	return;
    }
    if (!release_date.value) {
	error('Release Date is empty');
	return;
    }
    let versionInfo = {
	software_code: software_type.value,
	target_os: target_os.value,
	latest_version: latest_version.value,
	default_download_url: default_download_url.value,
	japanese_download_url: japanese_download_url.value,
	release_date: release_date.value,
	release_note: release_note.value
    };
    
    loading.value = true;
    try {
	let res = await addVersionInfo(versionInfo, serverOptions.value);
	await loadFromServer();
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
    await checkVersionInfo();
};

const update = async () => {
    if (!software_type.value) {
	error('Software Type is empty');
	return;
    }
    if (!target_os.value) {
	error('Target OS is empty');
	return;
    }
    if (!latest_version.value) {
	error('Latest Version is empty');
	return;
    }
    if (!default_download_url.value) {
	error('English Download URL is empty');
	return;
    }
    if (!japanese_download_url.value) {
	error('Japanese Download URL is empty');
	return;
    }
    if (!release_date.value) {
	error('Release Date is empty');
	return;
    }
    let versionInfo = {
	software_code: software_type.value,
	target_os: target_os.value,
	latest_version: latest_version.value,
	default_download_url: default_download_url.value,
	japanese_download_url: japanese_download_url.value,
	release_date: release_date.value,
	release_note: release_note.value,
	id: version_info_id.value
    };
    
    loading.value = true;
    try {
	let res = await updateVersionInfo(versionInfo, serverOptions.value);
	await loadFromServer();
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
    await checkVersionInfo();
};

const del = () => {
    confirm(realDel)
};

const realDel = async () => {
    let versionInfo = {
	id: version_info_id.value
    };
    
    loading.value = true;
    try {
	let res = await deleteVersionInfo(versionInfo, serverOptions.value);
	await loadFromServer();
    }
    catch(e){
	console.log(e)
    }
    finally {
	loading.value = false;
    }
    await checkVersionInfo();
};

const selectVersionInfo = async (data) => {
    version_info_id.value = data.id;
    software_type.value = data.software_code;
    target_os.value = data.target_os;
    latest_version.value = data.latest_version;
    default_download_url.value = data.default_download_url;
    japanese_download_url.value = data.japanese_download_url;
    release_date.value = data.release_date;
    release_note.value = data.release_note;
    await checkVersionInfo();
};

const checkVersionInfo = async () => {
    try {
	let res = await checkVersion(software_type.value,target_os.value);
	disable_add.value = !res.add;
	disable_update.value = !res.update;

	if (res.update) {
	    for (var i in items.value) {
	        if (items.value[i].id == res.update_id) {
		    version_info_id.value = items.value[i].id;
		    break;
		}
	    }
	} else {
	    version_info_id.value = 0;
	}
    }
    catch(e) {
	console.log(e)
    }
};

const bodyRowClassNameFunction = (item, index) => {
  let result = 'odd-row';
  if (item.id == version_info_id.value) {
    result = 'select-row';
  }
  return result;
};

</script>

<style scoped>
.app {
  font-size: 40px;
    color: blue;
}
.select-row {
  --easy-table-body-row-background-color: #f56c6c;
}
.odd-row {
  --easy-table-body-row-background-color: #ffffff;
}
.custom {
    --easy-table-header-background-color: #9df5bc;
}
</style>
